import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"variable\":\"--font-montserrat\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"montserrat\"}");
